import React from 'react'

function Referral() {
	return (
		<div className='text-green-700'>Customer Referral</div>
	)
}

export default Referral